const en = {
  // Nav
  nav_home: "Home",
  nav_shop: "Shop",
  nav_categories: "Categories",
  nav_best_selling: "Best Selling",
  nav_contact: "Contact",
  nav_reviews: "Reviews",
  my_account: "My Account",
  login_signup: "Login / Sign Up",

  // Hero defaults
  hero_subtitle: "Exclusive Collection by",
  hero_tagline: "Elegance in Every Thread",
  hero_button: "Shop Now",

  // Categories
  home_categories_subtitle: "Curated For You",
  home_categories_title: "Shop by Category",

  // Best selling
  home_bestselling_subtitle: "Most Loved",
  home_bestselling_title: "Best Selling Products",

  // Shop
  home_shop_subtitle: "Browse All",
  home_shop_title: "Shop by Collection",

  // Product card
  out_of_stock: "OUT OF STOCK",
  added_to_cart: "Added to cart",

  // Product detail
  kenani_collection: "Noor E Borka Collection",
  product_not_found: "Product not found",
  go_home: "Go Home",
  back: "Back",
  select_size: "Select Size",
  quantity: "Quantity",
  buy_now: "Buy Now",
  add_to_cart: "Add to Cart",
  please_select_size: "Please select a size",
  product_out_of_stock: "This product is out of stock",
  only_left: "Only {count} left in stock!",
  only_left_size: "Only {count} left in this size!",
  off: "OFF",
  you_may_also_like: "You May Also Like",
  similar_products: "Similar Products",
  related_products: "Related Products",
  recently_viewed: "Recently Viewed",
  please_login_wishlist: "Please login to add to wishlist",
  removed_from_wishlist: "Removed from wishlist",
  added_to_wishlist: "Added to wishlist",

  // Cart
  cart: "Cart",
  your_cart_empty: "Your cart is empty",
  continue_shopping: "Continue Shopping",
  total: "Total",
  checkout: "Checkout",
  size_label: "Size",

  // Checkout
  checkout_title: "Checkout",
  delivery_info: "Delivery Information",
  name_label: "Name",
  email_label: "Email (Optional)",
  phone_label: "Phone Number",
  address_label: "Delivery Address",
  your_name: "Your name",
  your_email: "your@email.com",
  phone_placeholder: "01XXXXXXXXX",
  address_placeholder: "Enter your full address",
  go_back: "Go Back",
  order_summary: "Order Summary",
  delivery_area: "Delivery Area",
  inside_dhaka: "Inside Dhaka",
  outside_dhaka: "Outside Dhaka",
  subtotal: "Subtotal",
  delivery: "Delivery",
  payment_method: "Payment Method",
  cash_on_delivery: "Cash on Delivery",
  coupon_code: "Coupon Code",
  enter_code: "Enter code",
  apply: "Apply",
  remove: "Remove",
  discount: "Discount",
  grand_total: "Grand Total",
  confirm_order: "Confirm Order",
  processing: "Processing...",
  required: "*",

  // Thank you
  thank_you: "Thank You!",
  order_confirmed: "Your order has been successfully confirmed.",
  order_number: "Order Number",
  we_will_contact: "We will contact you shortly. You can check your order status from the profile page.",
  representative_contact: "One of our customer representatives will contact you shortly to confirm your order.",
  need_help: "Need help? Reach out to us",
  call_us: "Call Us",
  whatsapp: "WhatsApp",
  message_us: "Message Us",
  view_orders: "View Orders",

  // Auth
  welcome_back: "Welcome Back",
  create_account: "Create Account",
  reset_password: "Reset Password",
  login_subtitle: "Log in to your account",
  signup_subtitle: "Create a new account",
  enter_email: "Enter your email",
  email: "Email",
  password: "Password",
  forgot_password: "Forgot password?",
  login: "Login",
  sign_up: "Sign Up",
  send_reset_link: "Send Reset Link",
  loading: "Loading...",
  or: "OR",
  continue_google: "Continue with Google",
  connecting: "Connecting...",
  no_account: "Don't have an account?",
  have_account: "Already have an account?",
  reset_link_sent: "A password reset link has been sent to your email.",

  // Profile
  back_to_shop: "Back to Shop",
  logout: "Logout",
  my_account_title: "My Account",
  profile: "Profile",
  orders: "Orders",
  full_name: "Full Name",
  phone: "Phone",
  address: "Address",
  save_profile: "Save Profile",
  saving: "Saving...",
  no_orders_yet: "You have no orders yet.",
  shop_now: "Shop Now",
  cancel: "Cancel",
  reorder: "Reorder",
  items: "items",
  tracking: "Tracking",
  courier_status: "Courier Status",

  // Wishlist
  my_wishlist: "My Wishlist",
  wishlist_empty: "Your wishlist is empty",
  browse_products: "Browse Products",

  // Order details
  back_to_profile: "Back to Profile",
  invoice: "Invoice",
  order_number_label: "Order Number",
  date: "Date",
  shipping_address: "Shipping Address",
  not_provided: "Not provided",
  items_label: "Items",
  no_items: "No items",
  qty: "Qty",
  cancel_order: "Cancel Order",
  total_amount: "Total Amount",

  // About
  our_story: "Our Story",
  our_vision: "Our Vision",
  our_vision_text: "We believe every woman deserves to feel confident and beautiful. Our collections are thoughtfully designed to celebrate the rich heritage of South Asian fashion while embracing modern sensibilities.",
  quality_promise: "Quality Promise",
  quality_promise_text: "Each garment is handpicked and quality-checked to ensure you receive nothing but the best. From premium cotton to luxurious embroidery, we source the finest materials for our collections.",
  contact_us: "Contact Us",

  // Info pages
  order_procedure_title: "Order Procedure",
  order_procedure_content: `Ordering from our website is very simple. Follow the steps below:

1. Select your desired product and choose a size.
2. Click the "Add to Cart" button.
3. Go to your cart and review your order.
4. Click the "Checkout" button.
5. Enter your name, phone number, and delivery address.
6. Confirm your order.
7. We will contact you by phone to confirm the order.
8. Pay via Cash on Delivery when the product is delivered.`,

  return_policy_title: "Return, Refund & Exchange Policy",
  return_policy_content: `We value customer satisfaction above all. Here is our return and exchange policy:

Return Policy

• Return/exchange requests must be made within 3 days of receiving the product.
• Products must be unused, undamaged, and in their original packaging.
• Customized or made-to-order products are not eligible for returns.
• Return shipping costs must be borne by the customer.

Refund Policy

• If a product is damaged or defective upon delivery, a full refund will be provided.
• Refunds will be processed to the original payment method within 5-7 business days after approval.
• For Cash on Delivery orders, refunds will be sent via bKash/Nagad to the customer's provided number.
• Partial refunds may be issued if only part of the order is returned.
• Refund requests must be accompanied by photos or videos as proof of the issue.
• Shipping charges are non-refundable unless the return is due to our error.

Exchange Policy

• Products can be exchanged for a different size or color within 3 days of delivery.
• The product must be unused and in its original packaging.
• If the exchanged product has a price difference, the customer must pay the additional amount.
• Exchange shipping costs must be borne by the customer.
• Exchange processing takes 3-5 business days after receiving the returned product.`,

  terms_title: "Terms & Conditions",
  terms_content: `By using this website, you agree to the following terms and conditions:

1. All product prices are displayed in Bangladeshi Taka (৳).
2. Product colors may vary slightly depending on your monitor/screen.
3. Product prices will not be changed after order confirmation.
4. Delivery typically takes 1-3 days inside Dhaka and 3-5 days outside Dhaka.
5. We reserve the right to modify these terms and conditions at any time.
6. No content from this website may be copied or used without permission.
7. Orders placed with incorrect information may be cancelled.`,

  privacy_title: "Privacy Policy",
  privacy_content: `Your privacy is extremely important to us. This policy describes how we collect, use, and protect your information:

• We only collect information necessary for order processing (name, phone, address, email).
• Your personal information is not sold or shared with third parties.
• Payment information is processed securely.
• Cookies are used to improve your browsing experience.
• You can request deletion of your account and data at any time.
• This policy may be updated from time to time.`,

  // Footer
  footer_contact: "Contact",
  footer_quick_links: "Quick Links",
  footer_information: "Information",
  footer_follow_us: "Follow Us",
  footer_home: "Home",
  footer_shop: "Shop",
  footer_categories: "Categories",
  footer_contact_link: "Contact",
  footer_order_procedure: "Order Procedure",
  footer_return_policy: "Return, Refund & Exchange",
  footer_terms: "Terms & Conditions",
  footer_privacy: "Privacy Policy",

  // Search
  search_placeholder: "Search products...",
  category_label: "Category",
  all_categories: "All Categories",
  min_price: "Min Price",
  max_price: "Max Price",
  sort_by: "Sort By",
  relevance: "Relevance",
  price_low_high: "Price: Low → High",
  price_high_low: "Price: High → Low",
  clear_filters: "Clear Filters",
  searching: "Searching...",
  no_products_found: "No products found",
  products_found: "{count} products found",

  // All Products
  all_products: "All Products",
  view_all: "View All",
  new_arrivals: "New Arrivals",
  latest_collection: "Latest Collection",
  filter_category: "Category",
  filter_sort: "Sort",
  sort_newest: "Newest",
  sort_price_low: "Price: Low to High",
  sort_price_high: "Price: High to Low",

  // Order Tracking
  track_order: "Track Order",
  track_order_subtitle: "Enter your order number to check the status",
  order_number_input: "Order Number",
  order_number_placeholder: "e.g. ORD-XXXXXX",
  track_button: "Track",
  order_not_found: "Order not found. Please check your order number.",
  order_status: "Order Status",
  status_pending: "Pending",
  status_confirmed: "Confirmed",
  status_processing: "Processing",
  status_shipped: "Shipped",
  status_delivered: "Delivered",
  status_cancelled: "Cancelled",
  status_returned: "Returned",
  ordered_on: "Ordered on",

  // Promo
  not_found: "Page Not Found",
  not_found_desc: "Sorry, the page you're looking for doesn't exist.",
  return_home: "Return Home",
};

const bn: typeof en = {
  // Nav
  nav_home: "হোম",
  nav_shop: "শপ",
  nav_categories: "ক্যাটাগরি",
  nav_best_selling: "বেস্ট সেলিং",
  nav_contact: "যোগাযোগ",
  nav_reviews: "রিভিউ",
  my_account: "আমার অ্যাকাউন্ট",
  login_signup: "লগইন / সাইন আপ",

  // Hero defaults
  hero_subtitle: "এক্সক্লুসিভ কালেকশন বাই",
  hero_tagline: "প্রতিটি সুতায় কমনীয়তা",
  hero_button: "এখনই কিনুন",

  // Categories
  home_categories_subtitle: "আপনার জন্য বিশেষ",
  home_categories_title: "ক্যাটাগরি অনুযায়ী কিনুন",

  // Best selling
  home_bestselling_subtitle: "সবচেয়ে জনপ্রিয়",
  home_bestselling_title: "বেস্ট সেলিং প্রোডাক্ট",

  // Shop
  home_shop_subtitle: "সব দেখুন",
  home_shop_title: "কালেকশন অনুযায়ী কিনুন",

  // Product card
  out_of_stock: "স্টক শেষ",
  added_to_cart: "কার্টে যোগ হয়েছে",

  // Product detail
  kenani_collection: "দামিনি কালেকশন",
  product_not_found: "প্রোডাক্ট পাওয়া যায়নি",
  go_home: "হোমে যান",
  back: "পিছনে",
  select_size: "সাইজ নির্বাচন করুন",
  quantity: "পরিমাণ",
  buy_now: "এখনই কিনুন",
  add_to_cart: "কার্টে যোগ করুন",
  please_select_size: "অনুগ্রহ করে একটি সাইজ নির্বাচন করুন",
  product_out_of_stock: "এই প্রোডাক্টটি স্টকে নেই",
  only_left: "মাত্র {count}টি বাকি আছে!",
  only_left_size: "এই সাইজে মাত্র {count}টি বাকি!",
  off: "ছাড়",
  you_may_also_like: "আপনার পছন্দ হতে পারে",
  similar_products: "একই ধরনের প্রোডাক্ট",
  related_products: "সম্পর্কিত পণ্য",
  recently_viewed: "সম্প্রতি দেখা পণ্য",
  please_login_wishlist: "উইশলিস্টে যোগ করতে লগইন করুন",
  removed_from_wishlist: "উইশলিস্ট থেকে সরানো হয়েছে",
  added_to_wishlist: "উইশলিস্টে যোগ হয়েছে",

  // Cart
  cart: "কার্ট",
  your_cart_empty: "আপনার কার্ট খালি",
  continue_shopping: "শপিং চালিয়ে যান",
  total: "মোট",
  checkout: "চেকআউট",
  size_label: "সাইজ",

  // Checkout
  checkout_title: "চেকআউট",
  delivery_info: "ডেলিভারি তথ্য",
  name_label: "নাম",
  email_label: "ইমেইল (ঐচ্ছিক)",
  phone_label: "ফোন নম্বর",
  address_label: "ডেলিভারি ঠিকানা",
  your_name: "আপনার নাম",
  your_email: "your@email.com",
  phone_placeholder: "০১XXXXXXXXX",
  address_placeholder: "আপনার সম্পূর্ণ ঠিকানা লিখুন",
  go_back: "পিছনে যান",
  order_summary: "অর্ডার সামারি",
  delivery_area: "ডেলিভারি এলাকা",
  inside_dhaka: "ঢাকার ভিতরে",
  outside_dhaka: "ঢাকার বাইরে",
  subtotal: "সাবটোটাল",
  delivery: "ডেলিভারি",
  payment_method: "পেমেন্ট পদ্ধতি",
  cash_on_delivery: "ক্যাশ অন ডেলিভারি",
  coupon_code: "কুপন কোড",
  enter_code: "কোড লিখুন",
  apply: "প্রয়োগ করুন",
  remove: "সরান",
  discount: "ছাড়",
  grand_total: "সর্বমোট",
  confirm_order: "অর্ডার নিশ্চিত করুন",
  processing: "প্রক্রিয়াকরণ হচ্ছে...",
  required: "*",

  // Thank you
  thank_you: "ধন্যবাদ!",
  order_confirmed: "আপনার অর্ডার সফলভাবে নিশ্চিত হয়েছে।",
  order_number: "অর্ডার নম্বর",
  we_will_contact: "আমরা শীঘ্রই আপনার সাথে যোগাযোগ করবো। আপনি প্রোফাইল পেইজ থেকে অর্ডারের স্ট্যাটাস দেখতে পারবেন।",
  representative_contact: "আমাদের একজন কাস্টমার প্রতিনিধি শীঘ্রই আপনার সাথে যোগাযোগ করবেন আপনার অর্ডার নিশ্চিত করতে।",
  need_help: "সাহায্য প্রয়োজন? আমাদের সাথে যোগাযোগ করুন",
  call_us: "কল করুন",
  whatsapp: "হোয়াটসঅ্যাপ",
  message_us: "মেসেজ করুন",
  view_orders: "অর্ডার দেখুন",

  // Auth
  welcome_back: "স্বাগতম",
  create_account: "অ্যাকাউন্ট তৈরি করুন",
  reset_password: "পাসওয়ার্ড রিসেট",
  login_subtitle: "আপনার অ্যাকাউন্টে লগইন করুন",
  signup_subtitle: "একটি নতুন অ্যাকাউন্ট তৈরি করুন",
  enter_email: "আপনার ইমেইল লিখুন",
  email: "ইমেইল",
  password: "পাসওয়ার্ড",
  forgot_password: "পাসওয়ার্ড ভুলে গেছেন?",
  login: "লগইন",
  sign_up: "সাইন আপ",
  send_reset_link: "রিসেট লিংক পাঠান",
  loading: "লোড হচ্ছে...",
  or: "অথবা",
  continue_google: "গুগল দিয়ে চালিয়ে যান",
  connecting: "সংযোগ হচ্ছে...",
  no_account: "অ্যাকাউন্ট নেই?",
  have_account: "ইতিমধ্যে অ্যাকাউন্ট আছে?",
  reset_link_sent: "আপনার ইমেইলে একটি পাসওয়ার্ড রিসেট লিংক পাঠানো হয়েছে।",

  // Profile
  back_to_shop: "শপে ফিরে যান",
  logout: "লগআউট",
  my_account_title: "আমার অ্যাকাউন্ট",
  profile: "প্রোফাইল",
  orders: "অর্ডার",
  full_name: "পূর্ণ নাম",
  phone: "ফোন",
  address: "ঠিকানা",
  save_profile: "প্রোফাইল সংরক্ষণ করুন",
  saving: "সংরক্ষণ হচ্ছে...",
  no_orders_yet: "আপনার এখনো কোনো অর্ডার নেই।",
  shop_now: "এখনই কিনুন",
  cancel: "বাতিল",
  reorder: "পুনরায় অর্ডার",
  items: "আইটেম",
  tracking: "ট্র্যাকিং",
  courier_status: "কুরিয়ার স্ট্যাটাস",

  // Wishlist
  my_wishlist: "আমার উইশলিস্ট",
  wishlist_empty: "আপনার উইশলিস্ট খালি",
  browse_products: "প্রোডাক্ট দেখুন",

  // Order details
  back_to_profile: "প্রোফাইলে ফিরে যান",
  invoice: "ইনভয়েস",
  order_number_label: "অর্ডার নম্বর",
  date: "তারিখ",
  shipping_address: "ডেলিভারি ঠিকানা",
  not_provided: "দেওয়া হয়নি",
  items_label: "আইটেম",
  no_items: "কোনো আইটেম নেই",
  qty: "পরিমাণ",
  cancel_order: "অর্ডার বাতিল করুন",
  total_amount: "মোট পরিমাণ",

  // About
  our_story: "আমাদের গল্প",
  our_vision: "আমাদের ভিশন",
  our_vision_text: "আমরা বিশ্বাস করি প্রতিটি নারী আত্মবিশ্বাসী ও সুন্দর অনুভব করার যোগ্য। আমাদের কালেকশনগুলো দক্ষিণ এশিয়ার ফ্যাশনের সমৃদ্ধ ঐতিহ্যকে আধুনিক রুচির সাথে মিলিয়ে তৈরি করা হয়েছে।",
  quality_promise: "গুণগত মানের প্রতিশ্রুতি",
  quality_promise_text: "প্রতিটি পোশাক হাতে বাছাই এবং গুণমান পরীক্ষিত, যাতে আপনি সেরাটাই পান। প্রিমিয়াম কটন থেকে বিলাসবহুল এমব্রয়ডারি, আমরা আমাদের কালেকশনের জন্য সবচেয়ে ভালো উপকরণ সংগ্রহ করি।",
  contact_us: "যোগাযোগ করুন",

  // Info pages
  order_procedure_title: "অর্ডার পদ্ধতি",
  order_procedure_content: `আমাদের ওয়েবসাইট থেকে অর্ডার করা খুবই সহজ। নিচের ধাপগুলো অনুসরণ করুন:

১. আপনার পছন্দের প্রোডাক্ট নির্বাচন করুন এবং সাইজ বেছে নিন।
২. "কার্টে যোগ করুন" বাটনে ক্লিক করুন।
৩. আপনার কার্টে গিয়ে অর্ডারটি দেখুন।
৪. "চেকআউট" বাটনে ক্লিক করুন।
৫. আপনার নাম, ফোন নম্বর এবং ডেলিভারি ঠিকানা দিন।
৬. আপনার অর্ডার নিশ্চিত করুন।
৭. আমরা ফোনে আপনার সাথে যোগাযোগ করে অর্ডার নিশ্চিত করবো।
৮. প্রোডাক্ট ডেলিভারির সময় ক্যাশ অন ডেলিভারিতে পেমেন্ট করুন।`,

  return_policy_title: "রিটার্ন, রিফান্ড ও এক্সচেঞ্জ পলিসি",
  return_policy_content: `গ্রাহক সন্তুষ্টি আমাদের কাছে সবচেয়ে গুরুত্বপূর্ণ। আমাদের রিটার্ন, রিফান্ড ও এক্সচেঞ্জ পলিসি:

রিটার্ন পলিসি

• প্রোডাক্ট পাওয়ার ৩ দিনের মধ্যে রিটার্ন/এক্সচেঞ্জের আবেদন করতে হবে।
• প্রোডাক্ট অব্যবহৃত, অক্ষতিগ্রস্ত এবং মূল প্যাকেজিংয়ে থাকতে হবে।
• কাস্টমাইজড বা মেড-টু-অর্ডার প্রোডাক্ট রিটার্নযোগ্য নয়।
• রিটার্ন শিপিং খরচ গ্রাহককে বহন করতে হবে।

রিফান্ড পলিসি

• ডেলিভারির সময় প্রোডাক্ট ক্ষতিগ্রস্ত বা ত্রুটিপূর্ণ থাকলে সম্পূর্ণ রিফান্ড প্রদান করা হবে।
• অনুমোদনের পর ৫-৭ কর্মদিবসের মধ্যে মূল পেমেন্ট মাধ্যমে রিফান্ড প্রক্রিয়া করা হবে।
• ক্যাশ অন ডেলিভারি অর্ডারের ক্ষেত্রে, গ্রাহকের প্রদত্ত নম্বরে বিকাশ/নগদের মাধ্যমে রিফান্ড পাঠানো হবে।
• অর্ডারের একটি অংশ রিটার্ন করলে আংশিক রিফান্ড প্রদান করা হতে পারে।
• রিফান্ড আবেদনের সাথে সমস্যার প্রমাণ হিসেবে ছবি বা ভিডিও দিতে হবে।
• আমাদের ভুলের কারণে রিটার্ন না হলে শিপিং চার্জ ফেরতযোগ্য নয়।

এক্সচেঞ্জ পলিসি

• ডেলিভারির ৩ দিনের মধ্যে ভিন্ন সাইজ বা রঙের জন্য প্রোডাক্ট এক্সচেঞ্জ করা যাবে।
• প্রোডাক্ট অব্যবহৃত এবং মূল প্যাকেজিংয়ে থাকতে হবে।
• এক্সচেঞ্জ করা প্রোডাক্টের দামে পার্থক্য থাকলে গ্রাহককে অতিরিক্ত টাকা পরিশোধ করতে হবে।
• এক্সচেঞ্জ শিপিং খরচ গ্রাহককে বহন করতে হবে।
• রিটার্ন করা প্রোডাক্ট পাওয়ার পর এক্সচেঞ্জ প্রক্রিয়ায় ৩-৫ কর্মদিবস সময় লাগবে।`,

  terms_title: "শর্তাবলী",
  terms_content: `এই ওয়েবসাইট ব্যবহার করার মাধ্যমে আপনি নিম্নলিখিত শর্তাবলীতে সম্মত হচ্ছেন:

১. সকল প্রোডাক্টের মূল্য বাংলাদেশী টাকায় (৳) প্রদর্শিত।
২. আপনার মনিটর/স্ক্রিনের উপর নির্ভর করে প্রোডাক্টের রঙে সামান্য পার্থক্য থাকতে পারে।
৩. অর্ডার নিশ্চিত হওয়ার পর প্রোডাক্টের মূল্য পরিবর্তন করা হবে না।
৪. ঢাকার ভিতরে ডেলিভারি ১-৩ দিন এবং ঢাকার বাইরে ৩-৫ দিন সময় নেয়।
৫. আমরা যেকোনো সময় এই শর্তাবলী পরিবর্তন করার অধিকার রাখি।
৬. এই ওয়েবসাইটের কোনো কনটেন্ট অনুমতি ছাড়া কপি বা ব্যবহার করা যাবে না।
৭. ভুল তথ্য দিয়ে দেওয়া অর্ডার বাতিল হতে পারে।`,

  privacy_title: "গোপনীয়তা নীতি",
  privacy_content: `আপনার গোপনীয়তা আমাদের কাছে অত্যন্ত গুরুত্বপূর্ণ। এই নীতিতে আমরা কীভাবে আপনার তথ্য সংগ্রহ, ব্যবহার এবং সুরক্ষা করি তা বর্ণনা করা হয়েছে:

• অর্ডার প্রক্রিয়ার জন্য প্রয়োজনীয় তথ্যই (নাম, ফোন, ঠিকানা, ইমেইল) শুধু সংগ্রহ করা হয়।
• আপনার ব্যক্তিগত তথ্য তৃতীয় পক্ষের কাছে বিক্রি বা শেয়ার করা হয় না।
• পেমেন্ট তথ্য নিরাপদভাবে প্রক্রিয়া করা হয়।
• আপনার ব্রাউজিং অভিজ্ঞতা উন্নত করতে কুকিজ ব্যবহার করা হয়।
• আপনি যেকোনো সময় আপনার অ্যাকাউন্ট ও ডাটা মুছে ফেলার অনুরোধ করতে পারেন।
• এই নীতি সময়ে সময়ে আপডেট হতে পারে।`,

  // Footer
  footer_contact: "যোগাযোগ",
  footer_quick_links: "দ্রুত লিংক",
  footer_information: "তথ্য",
  footer_follow_us: "আমাদের ফলো করুন",
  footer_home: "হোম",
  footer_shop: "শপ",
  footer_categories: "ক্যাটাগরি",
  footer_contact_link: "যোগাযোগ",
  footer_order_procedure: "অর্ডার পদ্ধতি",
  footer_return_policy: "রিটার্ন, রিফান্ড ও এক্সচেঞ্জ",
  footer_terms: "শর্তাবলী",
  footer_privacy: "গোপনীয়তা নীতি",

  // Search
  search_placeholder: "প্রোডাক্ট খুঁজুন...",
  category_label: "ক্যাটেগরি",
  all_categories: "সব ক্যাটেগরি",
  min_price: "সর্বনিম্ন মূল্য",
  max_price: "সর্বোচ্চ মূল্য",
  sort_by: "সর্ট করুন",
  relevance: "প্রাসঙ্গিকতা",
  price_low_high: "মূল্য: কম → বেশি",
  price_high_low: "মূল্য: বেশি → কম",
  clear_filters: "ফিল্টার মুছুন",
  searching: "খুঁজছি...",
  no_products_found: "কোনো প্রোডাক্ট পাওয়া যায়নি",
  products_found: "{count}টি প্রোডাক্ট পাওয়া গেছে",

  // All Products
  all_products: "সকল প্রোডাক্ট",
  view_all: "সব দেখুন",
  new_arrivals: "নতুন আগমন",
  latest_collection: "সর্বশেষ কালেকশন",
  filter_category: "ক্যাটাগরি",
  filter_sort: "সর্ট",
  sort_newest: "নতুন",
  sort_price_low: "মূল্য: কম থেকে বেশি",
  sort_price_high: "মূল্য: বেশি থেকে কম",

  // Order Tracking
  track_order: "অর্ডার ট্র্যাক করুন",
  track_order_subtitle: "অর্ডারের অবস্থা জানতে আপনার অর্ডার নম্বর দিন",
  order_number_input: "অর্ডার নম্বর",
  order_number_placeholder: "যেমন: ORD-XXXXXX",
  track_button: "ট্র্যাক করুন",
  order_not_found: "অর্ডার পাওয়া যায়নি। অনুগ্রহ করে অর্ডার নম্বর যাচাই করুন।",
  order_status: "অর্ডারের অবস্থা",
  status_pending: "পেন্ডিং",
  status_confirmed: "নিশ্চিত",
  status_processing: "প্রক্রিয়াধীন",
  status_shipped: "শিপড",
  status_delivered: "ডেলিভারি সম্পন্ন",
  status_cancelled: "বাতিল",
  status_returned: "রিটার্ন",
  ordered_on: "অর্ডারের তারিখ",

  // Other
  not_found: "পেইজ পাওয়া যায়নি",
  not_found_desc: "দুঃখিত, আপনি যে পেইজটি খুঁজছেন সেটি বিদ্যমান নেই।",
  return_home: "হোমে ফিরে যান",
};

export const translations = { en, bn } as const;
export type TranslationKey = keyof typeof en;
